import Box from '@material-ui/core/Box';
import { Theme } from '@material-ui/core/styles';
import createStyles from '@material-ui/core/styles/createStyles';
import makeStyles from '@material-ui/core/styles/makeStyles';
import React from 'react';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    content: {
      paddingBottom: theme.spacing(2),
      paddingTop: theme.spacing(2),
      [theme.breakpoints.up('lg')]: {
        paddingBottom: theme.spacing(1),
        paddingTop: theme.spacing(1),
      },
    },
    context: {
      paddingBottom: theme.spacing(1),
      paddingTop: theme.spacing(1),
    },
  })
);

export type Props = {
  children?: React.ReactNode;
  variant?: 'content' | 'context';
};

const Component: React.FC<Props> = ({ children, variant = 'content' }) => {
  const classes = useStyles();

  if (!children) {
    return null;
  }

  return (
    <Box className={classes[variant]} height={1}>
      {children}
    </Box>
  );
};

export default React.memo(Component);
